// TODO: Delete after V2 migration complete - replaced by timetableImportV2Api
import { apiClient, handleApiRequest } from './client'

export interface ParsedSession {
  session_id: string
  uploaded_file_id: string
  status: string
  total_entries_extracted: number
  total_teachers_identified: number
  high_confidence_count: number
  low_confidence_count: number
  conflict_count: number
  code_matches_found: number
  code_matches_verified: number
  started_at: string | null
  completed_at: string | null
  merge_strategy: string | null
}

export interface CodeMatch {
  match_id: string
  parsed_code: string
  teacher_id: string | null
  teacher_name: string | null
  confidence: number
  match_method: string
  is_verified: boolean
  verified_at: string | null
  alternative_matches: unknown[]
}

export interface ImportResult {
  entries_imported: number
  entries_skipped: number
  conflicts: number
  status: string
}

export interface VerificationQueueItem {
  match_id: string
  session_id: string | null
  parsed_code: string
  teacher_name: string | null
  confidence: number
  match_method: string
  is_verified: boolean
  alternative_matches: unknown[]
}

export interface MatchingReport {
  session_id: string
  total_matches: number
  verified_count: number
  high_confidence: number
  low_confidence: number
  average_confidence: number
  by_method: Record<string, number>
  by_confidence: Record<string, number>
  low_confidence_details: Array<{ parsed_code: string; confidence: number; match_method: string }>
}

export const timetableImportApi = {
  startSession: (data: { uploaded_file_id: string; teacher_code_examples?: Record<string, unknown>[]; parsing_config?: Record<string, unknown>; merge_strategy?: string }) =>
    handleApiRequest<ParsedSession>(apiClient.post('/api/v1/timetables/parsed/start-session', data)),

  getSession: (sessionId: string) =>
    handleApiRequest<ParsedSession>(apiClient.get(`/api/v1/timetables/parsed/sessions/${sessionId}`)),

  cancelSession: (sessionId: string) =>
    handleApiRequest<{ message: string }>(apiClient.delete(`/api/v1/timetables/parsed/sessions/${sessionId}`)),

  getCodeMatches: (sessionId: string, params?: { confidence_min?: number; is_verified?: boolean }) =>
    handleApiRequest<CodeMatch[]>(apiClient.get(`/api/v1/timetables/parsed/sessions/${sessionId}/code-matches`, { params })),

  verifyCodeMatch: (sessionId: string, matchId: string, data: { teacher_id?: string; is_verified?: boolean }) =>
    handleApiRequest<CodeMatch>(apiClient.post(`/api/v1/timetables/parsed/sessions/${sessionId}/code-matches/${matchId}/verify`, data)),

  rematchUnmatched: (sessionId: string) =>
    handleApiRequest<CodeMatch[]>(apiClient.post(`/api/v1/timetables/parsed/sessions/${sessionId}/code-matches/re-match`)),

  getConflicts: (sessionId: string) =>
    handleApiRequest<{ conflicts: Record<string, unknown>[]; total_conflicts: number }>(apiClient.get(`/api/v1/timetables/parsed/sessions/${sessionId}/conflicts`)),

  importEntries: (sessionId: string, data?: { import_mode?: string; verification_required?: boolean }) =>
    handleApiRequest<ImportResult>(apiClient.post(`/api/v1/timetables/parsed/sessions/${sessionId}/import`, data)),

  undoImport: (sessionId: string) =>
    handleApiRequest<{ message: string }>(apiClient.post(`/api/v1/timetables/parsed/sessions/${sessionId}/undo`)),

  getVerificationQueue: (status?: string) =>
    handleApiRequest<VerificationQueueItem[]>(apiClient.get('/api/v1/timetables/parsed/verification-queue', { params: { status: status || 'pending' } })),

  toggleVerificationStatus: (teacherId: string, data: { verification_status: 'green' | 'red' | 'pending' }) =>
    handleApiRequest<{ message: string }>(apiClient.patch(`/api/v1/timetables/parsed/teachers/${teacherId}/verification-status`, data)),

  createTeacherFromUnmatched: (matchId: string, data: { full_name: string; email?: string }) =>
    handleApiRequest<{ message: string }>(apiClient.post(`/api/v1/timetables/parsed/code-matches/${matchId}/create-teacher`, data)),

  getMatchingReport: (sessionId: string) =>
    handleApiRequest<MatchingReport>(apiClient.get(`/api/v1/timetables/parsed/sessions/${sessionId}/matching-report`)),
}

export default timetableImportApi
